// IconButton component override
export default function IconButton() {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px'
        },
        sizeLarge: {
          width: '48px',
          height: '48px',
          fontSize: '1.25rem'
        },
        sizeMedium: {
          width: '40px',
          height: '40px',
          fontSize: '1rem'
        },
        sizeSmall: {
          width: '32px',
          height: '32px',
          fontSize: '0.875rem'
        }
      }
    }
  };
}
